import * as releaseNotesService from "../services/releaseNotes";

export const releaseNotesActions: any = {
    releaseNotesWillLoad: "RELEASE_NOTES_WILL_LOAD",
    releaseNotesLoadSucceeded: "RELEASE_NOTES_LOAD_SUCCEEDED",
    releaseNotesLoadFailed: "RELEASE_NOTES_LOAD_FAILED",
    resetStates: "RELEASE_NOTES_RESET_STATES",
};


export const fetchReleaseNotesList = ({ page, limit, searchText, status, type }: { page: number; limit: number; searchText?: string; status?: string; type?: string }) =>
    async (dispatch: any) => {
        dispatch({
            type: releaseNotesActions.releaseNotesWillLoad,
            payload: {
                page,
                limit,
            },
        });
        try {
            dispatch({
                type: releaseNotesActions.releaseNotesLoadSucceeded,
                payload: await releaseNotesService.fetchReleaseNotes(page, limit, searchText, status, type),
            });
        } catch (err) {
            dispatch({
                type: releaseNotesActions.releaseNotesLoadFailed,
                payload: err,
            });
        }
    };

export const resetStates = () => ({
    type: releaseNotesActions.resetStates,
});
